import clsx from 'clsx';

import { genericMemo } from '../../utils';
import { useStyles } from './ListData.styles';
import { ListDataProps } from './ListData.types';

export const ListData = genericMemo(
  <T,>({
    data,
    direction = 'col',
    gap = 8,
    align = 'start',
    justify = 'start',
    loading,
    className,
    classes,
    getItemComponent,
  }: ListDataProps<T>) => {
    const styles = useStyles({ direction, gap, align, justify });

    if (loading?.value) {
      return (
        <div className={clsx(styles.list, className, classes?.list)}>
          {Array.from({ length: loading.skeletonCount ?? 5 }).map((_, index) => loading.getSkeletonContent?.(index))}
        </div>
      );
    }

    if (!data.length) {
      return null;
    }

    return (
      <div className={clsx(styles.list, className, classes?.list)}>
        {data.map((item, index) => getItemComponent(item, index))}
      </div>
    );
  },
);
